<template>
  <div
    class="modal fade"
    id="ModalAddNewPerson"
    tabindex="99"
    role="dialog"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-notify modal-info"
      role="document"
      style="max-width: 600px"
    >
      <!--Content-->
      <div class="modal-content text-center" style="height: 90vh">
        <!--Header-->
        <div class="modal-header d-flex justify-content-center">
          <p class="heading">ثبت شخص جدید</p>
        </div>

        <!--Body-->
        <div class="modal-body px-4 py-2" style="height: 100%; overflow: auto">
          <p class="h6 mt-4 text-info">ثبت اطلاعات اصلی</p>
          <div class="row">
            <!-- کادر نام استان -->
            <div class="col-6 position-relative">
              <select
                id="selectOrg"
                class="form-control mt-1 text-center selectStyle"
                v-model="PersonData.NPerProvinceCode"
              >
                <option
                  v-for="option in getNPerProvince"
                  v-bind:key="option.NPerProvinceCode"
                  v-bind:value="option.NPerProvinceCode"
                >
                  {{ option.NPerProvinceText }}
                </option>
              </select>
              <i title="استان (اجباری)" class="far fa-flag fa-1x-half position-absolute iconStyle MandatoryStyle"></i>
            </div>
            <!-- کادر نام شهر -->
            <div class="col-6 position-relative">
              <select
                id="selectOrg"
                class="form-control mt-1 text-center selectStyle"
                v-model="PersonData.NPerCityCode"
              >
                <option
                  v-for="option in getNPerCity"
                  v-bind:key="option.NPerCityCode"
                  v-bind:value="option.NPerCityCode"
                >
                  {{ option.NPerCityText }}
                </option>
              </select>
              <i title="شهر (اجباری)" class="far fa-flag fa-1x-half position-absolute iconStyle MandatoryStyle"></i>
            </div>
            <!-- کادر نوع شخصیت -->
            <div class="col-6 position-relative">
              <select
                id="selectNPerType"
                class="form-control mt-1 text-center selectStyle"
                v-model="PersonData.NPerType"
              >
                <option
                  v-for="option in getNPerType"
                  v-bind:key="option.NPerTypeCode"
                  v-bind:value="option.NPerTypeCode"
                >
                  {{ option.NPerTypeText }}
                </option>
              </select>
              <i
                class="
                  fas
                  fa-user-friends fa-1x-half
                  position-absolute
                  iconStyle
                  MandatoryStyle
                "
                title="نوع شخصیت (اجباری)"
              ></i>
            </div>
            <!-- کادر تابعیت -->
            <div class="col-6 position-relative">
              <select
                id="selectOrg"
                class="form-control mt-1 text-center selectStyle"
                v-model="PersonData.NPerNationalType"
              >
                <option
                  v-for="option in getNPerNationalType"
                  v-bind:key="option.NPerNationalTypeCode"
                  v-bind:value="option.NPerNationalTypeCode"
                >
                  {{ option.NPerNationalTypeText }}
                </option>
              </select>
              <i
                class="
                  far
                  fa-flag fa-1x-half
                  position-absolute
                  iconStyle
                  MandatoryStyle
                "
                title="تابعیت (اجباری)"
              ></i>
            </div>
            <!-- کادر شماره ملی -->
            <div class="col-6 position-relative">
              <input
                type="text"
                placeholder="شماره ملی"
                class="form-control text-center mt-2"
                v-model="PersonData.SPerNationalId"
                autocomplete="off"
                style="direction: ltr"
                v-bind:maxlength="PersonData.NPerType == 1 ? 10 : 11"
                v-on:keypress="onlyNumberAccept"
              />
              <i
                class="
                  far
                  fa-address-card fa-1x-half
                  position-absolute
                  iconStyle
                  MandatoryStyle
                "
                title="شماره ملی (اجباری)"
                style="top: 25%"
              ></i>
            </div>
            <!-- کادر کد اقتصادی -->
            <div class="col-6 position-relative">
              <input
                type="text"
                placeholder="کد اقتصادی"
                class="form-control text-center mt-1"
                v-model="PersonData.NPerTaxNu"
                autocomplete="off"
                style="direction: ltr"
                maxlength="12"
                v-on:keypress="onlyNumberAccept"
              />
              <i
                title="کد اقتصادی"
                class="far fa-building fa-1x-half position-absolute iconStyle"
              ></i>
            </div>
            <!-- کادر نام -->
            <div class="col-6 position-relative">
              <input
                type="text"
                placeholder="نام"
                class="form-control text-center mt-1"
                v-model="PersonData.NPerName"
                autocomplete="off"
                maxlength="50"
              />
              <i title="نام" class="fas fa-user fa-1x-half position-absolute iconStyle"></i>
            </div>
            <!-- کادر نام خانوادگی -->
            <div class="col-6 position-relative">
              <input
                type="text"
                placeholder="نام خانوادگی"
                class="form-control text-center mt-1"
                v-model="PersonData.NPerLastName"
                autocomplete="off"
                maxlength="100"
              />
              <i
                class="
                  fas
                  fa-users fa-1x-half
                  position-absolute
                  iconStyle
                  MandatoryStyle
                "
                title="نام خانوادگی (اجباری)"
              ></i>
            </div>
            <!-- کادر نام پدر -->
            <div class="col-6 position-relative">
              <input
                type="text"
                placeholder="نام پدر"
                class="form-control text-center mt-1"
                v-model="PersonData.NPerFatherName"
                autocomplete="off"
                maxlength="100"
              />
              <i title="نام پدر" class="far fa-user fa-1x-half position-absolute iconStyle"></i>
            </div>
            <!-- کادر تلفن -->
            <div class="col-6 position-relative">
              <input
                type="text"
                placeholder="تلفن"
                class="form-control text-center mt-1"
                v-model="PersonData.NPerTel"
                autocomplete="off"
                style="direction: ltr"
                maxlength="11"
                v-on:keypress="onlyNumberAccept"
              />
              <i
                class="fas fa-phone fa-1x-half position-absolute iconStyle"
                title="تلفن"
              ></i>
            </div>
            <!-- کادر تلفن همراه -->
            <div class="col-6 position-relative">
              <input
                type="text"
                placeholder="تلفن همراه"
                class="form-control text-center mt-1"
                v-model="PersonData.SMobileNu"
                autocomplete="off"
                style="direction: ltr"
                maxlength="11"
                v-on:keypress="onlyNumberAccept"
              />
              <i
                class="fas fa-mobile-alt fa-1x-half position-absolute iconStyle"
                title="تلفن همراه"
              ></i>
            </div>
            <!-- کادر کد پستی -->
            <div class="col-6 position-relative">
              <input
                type="text"
                placeholder="کد پستی"
                class="form-control text-center mt-1"
                v-model="PersonData.NPerPostcalCode"
                autocomplete="off"
                style="direction: ltr"
                maxlength="10"
                v-on:keypress="onlyNumberAccept"
              />
              <i
                class="
                  fas
                  fa-map-marked-alt fa-1x-half
                  position-absolute
                  iconStyle
                "
                title="کد پستی"
              ></i>
            </div>
            <!-- کادر نشانی -->
            <div class="col-12 position-relative">
              <input
                type="text"
                placeholder="نشانی"
                class="form-control text-center mt-1"
                v-model="PersonData.NPerAddress"
                autocomplete="off"
                maxlength="80"
              />
              <i title="نشانی" class="fas fa-home fa-1x-half position-absolute iconStyle"></i>
            </div>
            <!-- کادر نوع کالا/خدمات -->
            <div class="col-6 position-relative">
              <select
                id="selectOrg"
                class="form-control mt-1 text-center selectStyle"
                v-model="PersonData.NPerKalaType"
              >
                <option
                  v-for="option in getNPerKalaType"
                  v-bind:key="option.NPerKalaTypeCode"
                  v-bind:value="option.NPerKalaTypeCode"
                >
                  {{ option.NPerKalaTypeText }}
                </option>
              </select>
              <i
                class="fas fa-box-open fa-1x-half position-absolute iconStyle"
                title="نوع کالا/خدمات"
              ></i>
            </div>
            <!-- کادر گروه -->
            <div class="col-6 position-relative">
              <select
                id="selectOrg"
                class="form-control mt-1 text-center selectStyle"
                v-model="PersonData.NGroup"
              >
                <option
                  v-for="option in getNGroup"
                  v-bind:key="option.NGroupCode"
                  v-bind:value="option.NGroupCode"
                >
                  {{ option.NGroupText }}
                </option>
              </select>
              <i
                class="
                  fas
                  fa-layer-group fa-1x-half
                  position-absolute
                  iconStyle
                "
                title="گروه"
              ></i>
            </div>
            <!-- کادر نوع مودی -->
            <div class="col-6 position-relative">
              <select
                id="selectOrg"
                class="form-control mt-1 text-center selectStyle"
                v-model="PersonData.NPerTaxType"
              >
                <option
                  v-for="option in getNPerTaxType"
                  v-bind:key="option.NPerTaxTypeCode"
                  v-bind:value="option.NPerTaxTypeCode"
                >
                  {{ option.NPerTaxTypeText }}
                </option>
              </select>
              <i
                class="fas fa-building fa-1x-half position-absolute iconStyle"
                title="نوع مودی"
              ></i>
            </div>
            <!-- کادر شماره شناسایی حقوق -->
            <div class="col-6 position-relative">
              <input
                type="text"
                placeholder="شماره شناسایی حقوق"
                class="form-control text-center mt-1"
                v-model="PersonData.NPerIDPay"
                autocomplete="off"
                style="direction: ltr"
                maxlength="10"
                v-on:keypress="onlyNumberAccept"
              />
              <i
                class="
                  fas
                  fa-money-check-alt fa-1x-half
                  position-absolute
                  iconStyle
                "
                title="شماره شناسایی حقوق"
              ></i>
            </div>
          </div>

          <p class="h6 mt-4 text-info">ثبت اطلاعات تکمیلی</p>

          <div class="row">
            <!-- کادر شغل -->
            <div class="col-6 position-relative">
              <input
                type="text"
                placeholder="شغل"
                class="form-control text-center mt-1"
                v-model="PersonData.SJob"
                autocomplete="off"
                maxlength="30"
              />
              <i
                class="fas fa-user-md fa-1x-half position-absolute iconStyle"
                title="شغل"
              ></i>
            </div>
            <!-- کادر شماره فکس -->
            <div class="col-6 position-relative">
              <input
                type="text"
                placeholder="شماره فکس"
                class="form-control text-center mt-1"
                v-model="PersonData.SFaxNu"
                autocomplete="off"
                style="direction: ltr"
                maxlength="11"
                v-on:keypress="onlyNumberAccept"
              />
              <i title="فکس" class="fas fa-fax fa-1x-half position-absolute iconStyle"></i>
            </div>
            <!-- کادر نام فروشگاه -->
            <div class="col-12 position-relative">
              <input
                type="text"
                placeholder="نام فروشگاه"
                class="form-control text-center mt-1"
                v-model="PersonData.SShopName"
                autocomplete="off"
                maxlength="30"
              />
              <i
                class="
                  fas
                  fa-shopping-cart fa-1x-half
                  position-absolute
                  iconStyle
                "
                title="نام فروشگاه"
              ></i>
            </div>

            <!-- کادر شماره حساب -->
            <div class="col-6 position-relative">
              <input
                type="text"
                placeholder="شماره حساب"
                class="form-control text-center mt-1"
                v-model="PersonData.SAccNu"
                autocomplete="off"
                style="direction: ltr"
                maxlength="30"
                v-on:keypress="onlyNumberAccept"
              />
              <i
                class="
                  fas
                  fa-money-check-alt fa-1x-half
                  position-absolute
                  iconStyle
                "
                title="شماره حساب"
              ></i>
            </div>
            <!-- کادر شماره کارت -->
            <div class="col-6 position-relative">
              <!-- <input
                type="text"
                placeholder="شماره کارت"
                class="form-control text-center mt-1"
                v-model="PersonData.SAccCardNu"
                autocomplete="off"
                style="direction: ltr"
                maxlength="19"
                v-on:keypress="onlyNumberAccept"
              /> -->
              <the-mask
                type="text"
                placeholder="شماره کارت"
                class="form-control text-center mt-1"
                :mask="['####-####-####-####']"
                :masked="true"
                v-model="PersonData.SAccCardNu"
              />
              <i
                class="
                  fas
                  fa-money-check fa-1x-half
                  position-absolute
                  iconStyle
                "
                title="شماره کارت"
              ></i>
            </div>
            <!-- کادر شناسه شبا -->
            <div class="col-6 position-relative">
              <input
                type="text"
                placeholder="شناسه شبا"
                class="form-control text-center mt-1"
                v-model="PersonData.SAccIRNu"
                autocomplete="off"
                style="direction: ltr"
                maxlength="24"
              />
              <i
                class="fas fa-ellipsis-h fa-1x-half position-absolute iconStyle"
                title="شناسه شبا"
              ></i>
            </div>
            <!-- کادر نام بانک -->
            <div class="col-6 position-relative">
              <select
                id="selectOrg"
                class="form-control mt-1 text-center selectStyle"
                v-model="PersonData.NAccBank"
              >
                <option
                  v-for="option in getNAccBank"
                  v-bind:key="option.NCode"
                  v-bind:value="option.NCode"
                >
                  {{ option.SDesc }}
                </option>
              </select>
              <i
                class="fas fa-university fa-1x-half position-absolute iconStyle"
                title="نام بانک"
              ></i>
            </div>
          </div>
        </div>

        <!--Footer-->
        <div class="modal-footer flex-center px-4" style="height: 15%">
          <a
            class="btn btn-info waves-effect waves-light"
            v-bind:class="checkConnectToServer ? 'disabled btn-pink': ''"
            v-on:click="SaveNewPerson()"
            >
            <i v-if="checkConnectToServer" class="fas fa-sync fa-spin fa-1x ml-2"></i>
            ثبت شخص جدید
            </a>
          <a
            class="btn btn-outline-info waves-effect waves-light"
            v-bind:class="checkConnectToServer ? 'disabled': ''"
            style="padding-top: 0.375rem; padding-bottom: 0.375rem"
            data-dismiss="modal"
            >انصراف</a
          >
        </div>
      </div>
      <!--/.Content-->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // اطلاعات شخصیت
      PersonData: {
        NUserCode: 0,  // کد کاربر مدیر
        SPerNationalId: "", // شماره ملی
        NPerTaxNu: "", // کد اقتصادی
        NPerNationalType: 0, // نوع شماره ملی
        NPerType: 0, // نوع شخص - حقیقی/حقوقی
        NPerTaxType: 0, // نوع مودی
        NPerName: "", // نام شخص
        NPerLastName: "", // نام خانوادگی
        NPerProvinceCode: 0, // کد استان
        NPerCityCode: 0, // کد شهر
        NPerAddress: "", // آدرس
        NPerTelCode: "", // کد تلفن
        NPerTel: "", // تلفن
        NPerPostcalCode: "", // کد پستی
        NPerKalaType: 0, // نوع کالا/خدمات
        SDate: "", // تاریخ ثبت
        DTime: "", // ساعت ثبت
        SJob: "", // شغل شخص
        SShopName: "", // نام فروشگاه
        SMobileNu: "", // تلفن همراه
        SFaxNu: "", // شماره فکس
        SAccNu: "", // شماره حساب
        SAccCardNu: "", // شماره کارت
        SAccIRNu: "", // شماره شبا
        NAccBank: 0, // نام بانک
        NPerFatherName: "", // نام پدر
        NYear: 0, // سال
        NGroup: 0, // کد گروه
        NPerIDPay: 0, // شماره شناسایی حقوق
      },
      // کنترل وضعیت اتصال به سرور
      checkConnectToServer: false,
    };
  },
  computed: {
    // دریافت لیست سازمان ها
    getTbBaseOrgData() {
      return this.$store.getters.getTbBaseOrgData;
    },
    // دریافت نوع شخصیت
    getNPerType() {
      return this.$store.getters.getNPerType;
    },
    // دریافت نوع مودی
    getNPerTaxType() {
      return this.$store.getters.getNPerTaxType;
    },
    // دریافت نوع کالا/خدمات
    getNPerKalaType() {
      return this.$store.getters.getNPerKalaType;
    },
    // دریافت لیست گروه
    getNGroup() {
      return this.$store.getters.getNGroup;
    },
    // دریافت لیست تابعیت
    getNPerNationalType() {
      return this.$store.getters.getNPerNationalType;
    },
    // دریافت لیست استان ها
    getNPerProvince() {
      return this.$store.getters.getNPerProvince;
    },
    // دریافت لیست شهرها
    getNPerCity() {
      let tempData = this.$store.getters.getNPerCity(this.PersonData.NPerProvinceCode);
      if(tempData.length > 0){
        this.PersonData.NPerCityCode = tempData[0].NPerCityCode;
      } else {
        this.PersonData.NPerCityCode = 0;
      }
      return tempData
    },
    // دریافت لیست بانک ها
    getNAccBank() {
      return this.$store.getters.getTbBaseBankData;
    },
  },
  methods: {
    // درج فقط عدد مجاز است
    onlyNumberAccept($event) {
      if (!/\d/.test($event.key)) {
        return $event.preventDefault();
      }
    },
    // ذخیره تغییرات حساب کاربری
    async SaveNewPerson() {
      // آیا نوع شخصیت مشخص شده است ؟
      if (this.PersonData.NPerType != 0) {
        // آیا شماره ملی مقدار دهی شده است ؟
        if (this.PersonData.SPerNationalId != "") {
          // آیا نام خانوادگی ثبت شده است ؟
          if (this.PersonData.NPerLastName != "") {
            // آیا تابعیت مشخص شده است ؟
            if(this.PersonData.NPerNationalType != 0) {
              // آیا استان مشخص شده است ؟
              if(this.PersonData.NPerProvinceCode != 0){
                if( this.PersonData.NPerCityCode != 0){
                  // اعلام اتصال به سرور
                  this.checkConnectToServer = true;
                  // دریافت توکن احراز هویت
                  let token = await this.$store.getters.getUserData.token;
                  // کد کاربری
                  let NUserCode = await this.$store.getters.getUserData.NUserCode; 
                  // دریافت تاریخ ثبت
                  this.PersonData.SDate = this.$store.getters.getPersianDateValue.PersianDate;
                  // درج ساعت ثبت
                  // چون فیلد مورد نظر از نوع 
                  // DateTime
                  //  هست لذا باید فرمت 
                  // ISO 
                  // استفاده شود
                  this.PersonData.DTime = new Date().toISOString();
                  // درج کد کاربر جاری
                  this.PersonData.NUserCode = NUserCode;
                  // ثبت شخصیت جدید در سرور
                  let check = await this.$store.dispatch("SaveNewPersonToServer", {
                    PersonData: this.PersonData,
                    token: token,
                  });
                  if(check == true){
                    // بستن مودال ثبت شخصیت جدید
                    $("#ModalAddNewPerson").modal("hide");
                    // اعلام اعمال تغییرات به والد
                    this.$emit("AddNewPerson", this.PersonData);
                  }
                } else {
                  // ثبت شهر الزامی است
                  this.$store.dispatch("notify", {
                    notText: "عدم تعیین شهر : تعیین شهر الزامی است !",
                    timeOut: 2500,
                  });
                }
              } else {
                // ثبت استان الزامی است
                this.$store.dispatch("notify", {
                  notText: "عدم تعیین استان : تعیین استان الزامی است !",
                  timeOut: 2500,
                });
              }
            } else {
              // ثبت تابعیت الزامی است
              this.$store.dispatch("notify", {
                notText: "عدم تعیین تابعیت : تعیین تابعیت الزامی است !",
                timeOut: 2500,
              });
            }
          } else {
            // ثبت نام خانوادگی الزامی است
            this.$store.dispatch("notify", {
              notText: "عدم درج نام خانوادگی : درج نام خانوادگی الزامی است !",
              timeOut: 2500,
            });
          }
        } else {
          // ثبت شماره ملی الزامی است
          this.$store.dispatch("notify", {
            notText: "عدم درج شماره ملی : درج شماره ملی الزامی است !",
            timeOut: 2500,
          });
        }
      } else {
        // ثبت نوع شخصیت الزامی است
        this.$store.dispatch("notify", {
          notText: "عدم تعیین نوع شخصیت : تعیین نوع شخصیت الزامی است !",
          timeOut: 2500,
        });
      }
      // اعلام اتمام اتصال به سرور
      this.checkConnectToServer = false;
    },
  },
};
</script>

<style>
/* استایل آیکون کنار فیلدها */
.iconStyle {
  top: 18%;
  right: 0px;
  border-radius: 50%;
  background-color: #e6f2fd;
  border: 1px solid #ced4da;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* استایل فیلدهای اجباری */
.MandatoryStyle {
  background-color: #fde6e6;
}
/* استایل انتخاب سطر */
.selectStyle {
  font-size: 12px;
  height: 38px;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ListTarafHesabha/Components/AddNewPerson.vue